import { useShallow } from 'zustand/shallow';

import { store } from './store';

export const usePhotographer = () =>
  store(
    useShallow((state) => ({
      data: state.data,
      loading: state.loading,
      updating: state.updating,
      error: state.error,
      fetch: state.fetch,
      moderate: state.moderate,
      updateSpotlight: state.updateSpotlight,
      reset: state.reset,
    })),
  );
